import styled from 'styled-components';
import React from 'react';
import { colors } from '../../../../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../../../../constants/text';
import InsurerPhone from '../../../../../../../Account/Profile/Insurance/util/InsurerPhone';
import useInsuranceCarrierDisplayProperties from '../../hooks/useInsuranceCarrierDisplayProperties';
import useSelectInsuranceProfile from '../../../../../../hooks/useSelectInsuranceProfile';
import { safeGet } from '../../../../../../../../core/util/object';
import { ACCOUNT_CALL_INSURANCE_CARRIER } from '../../../../../../../../core/analytics/events';

const CarrierInfoContainer = styled.div.withConfig({ componentId: 'sc-47dl1n-0' })`
  border-top: 1px solid ${colors.granite};
  background-color: ${colors.whiteGrey};
  padding-top: 25px;
  padding-bottom: 25px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 0 0 16px 16px;
  font-size: ${fontSize.mediumSmall};
`;

const MemberServices = styled.span.withConfig({ componentId: 'sc-47dl1n-1' })`
  font-family: ${fontFamily.bold};
  color: ${colors.darkText};
`;

const CarrierPhone = styled(InsurerPhone).withConfig({ componentId: 'sc-47dl1n-2' })`
  margin-left: 5px;
`;

type Props = {
  userProfileId: string;
};

const CarrierContactInfo = (props: Props) => {
  const { userProfileId } = props;
  const insuranceCarrierDisplayProperties = useInsuranceCarrierDisplayProperties(userProfileId);
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);

  const insurerPhone = safeGet(insuranceCarrierDisplayProperties)('phoneNumber');
  const insurerType = safeGet(insuranceProfile)('insurer_type');
  const insurerCode = safeGet(insuranceProfile)('insurer_code');
  const insuranceCarrierName = safeGet(insuranceProfile)('insurer_name');

  if (insuranceCarrierDisplayProperties) {
    return (
      <CarrierInfoContainer>
        <MemberServices>Member services:</MemberServices>{' '}
        <CarrierPhone
          insuranceCarrierDisplayProperties={insuranceCarrierDisplayProperties}
          insuranceCarrierName={insuranceCarrierName}
          insurerCode={insurerCode}
          insurerPhone={insurerPhone}
          insurerType={insurerType}
          trackingCode={ACCOUNT_CALL_INSURANCE_CARRIER}
        />
      </CarrierInfoContainer>
    );
  }
  return null;
};

export default CarrierContactInfo;
